<template>
  <footer class="apple-tesla-footer">
    <b-container class="py-5">
      <!-- Grid Principal Footer -->
      <b-row class="gy-4">

        <!-- Coloana 1: Rețele Sociale -->
        <b-col lg="4" md="6" class="mb-4 mb-lg-0">
          <h4 class="footer-heading">Urmărește-ne</h4>
          <p class="footer-subtext">Rămâi conectat cu ultimele noutăți și oferte speciale.</p>
          <ul class="footer-links social-links">
            <li>
              <a target="_blank" href="https://www.facebook.com/CoressyDelivery" class="footer-link">
                <svg class="social-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                Facebook
              </a>
            </li>
            <li>
              <a target="_blank" href="https://www.instagram.com/coressy_delivery/" class="footer-link">
                <svg class="social-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
                Instagram
              </a>
            </li>
            <li>
              <a target="_blank" href="https://www.tiktok.com/@coressydelivery" class="footer-link">
                <svg class="social-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-.97 1.36-2.43 2.3-4.06 2.67-1.68.39-3.47.16-5.01-.62-1.49-.75-2.67-2.02-3.27-3.57-.63-1.62-.62-3.46.03-5.07.61-1.52 1.83-2.74 3.37-3.37 1.38-.57 2.93-.65 4.36-.26v4.06c-.82-.24-1.72-.18-2.48.21-.75.38-1.31 1.07-1.53 1.88-.23.8-.04 1.68.48 2.32.51.64 1.31.99 2.13.94.88-.04 1.67-.54 2.08-1.31.32-.61.42-1.32.41-2.01l.04-14.89z"/></svg>
                TikTok
              </a>
            </li>
          </ul>
        </b-col>

        <!-- Coloana 2: Legături Utile -->
        <b-col lg="4" md="6" class="mb-4 mb-lg-0">
          <h4 class="footer-heading">Parteneriate &amp; Oportunități</h4>
          <ul class="footer-links">
            <li>
              <router-link :to="{ name: 'public.register.driver'}" class="footer-link">
                Vreau să devin livrator
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'public.register.company'}" class="footer-link">
                Înregistrează companie
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'public.register.partner'}" class="footer-link">
                Deții un restaurant?
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'public.register.francise'}" class="footer-link">
                Vrei o franciză?
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'public.register.delete'}" class="footer-link muted-link">
                Șterge datele mele
              </router-link>
            </li>
          </ul>
        </b-col>

        <!-- Coloana 3: Aplicații & Contact -->
        <b-col lg="4" md="12">
          <h4 class="footer-heading">Aplicații &amp; Suport</h4>
          <p class="footer-subtext">Descarcă aplicația Coressy direct pe telefonul tău.</p>

          <div class="app-buttons">
            <a href="https://bit.ly/coressy-iphone" target="_blank" class="app-chip-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.32c.63-.77 1.06-1.83.94-2.91-.91.04-2.03.61-2.68 1.37-.58.68-1.09 1.77-.95 2.83 1.02.08 2.06-.52 2.69-1.29z"/></svg>
              <span>App Store</span>
            </a>

            <a href="https://bit.ly/coressy-android" target="_blank" class="app-chip-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.523 15.3414c-.5511 0-.9993-.4486-.9993-.9997 0-.551.4482-.9993.9993-.9993.551 0 .9993.4483.9993.9993 0 .5511-.4483.9997-.9993.9997m-11.046 0c-.5511 0-.9993-.4486-.9993-.9997 0-.551.4482-.9993.9993-.9993.551 0 .9993.4483.9993.9993 0 .5511-.4482.9997-.9993.9997m11.4045-6.02l1.9973-3.4592a.416.416 0 0 0-.1521-.5676.416.416 0 0 0-.5676.1521l-2.0223 3.503C15.5882 8.207 13.8562 7.7813 12 7.7813c-1.8562 0-3.5882.4257-5.1368 1.1685L4.8409 5.4468a.416.416 0 0 0-.5676-.1521.416.416 0 0 0-.1521.5676l1.9973 3.4592C2.6888 11.2865.3435 14.8377.0188 19h23.9624c-.3247-4.1623-2.67-7.7135-6.0997-9.6786"/></svg>
              <span>Google Play</span>
            </a>

            <a href="https://bit.ly/c-appgallery" target="_blank" class="app-chip-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14.5v-9l6 4.5-6 4.5z"/></svg>
              <span>AppGallery</span>
            </a>
          </div>

          <div class="contact-email mt-3">
            <span class="email-label">Suport clienți:</span>
            <a href="mailto:info@coressy.com" class="email-link">info@coressy.com</a>
          </div>
        </b-col>

      </b-row>

      <hr class="footer-divider my-4" />

      <!-- Subsol Legal & Plăți (Aliniere Corectată) -->
      <b-row class="align-items-center">

        <!-- Stânga: Copyright + Linkuri Legale perfect aliniate -->
        <b-col md="7" lg="8" class="mb-3 mb-md-0 text-center text-md-left">
          <div class="bottom-legal-info">
            <span class="copyright-text">
              © 2026 <strong>coressy.com</strong>. Toate drepturile rezervate.
            </span>
            <span class="dot-separator d-none d-sm-inline">•</span>
            <div class="legal-inline-links">
              <router-link :to="{ name: 'public.gdpr' }" class="legal-link">
                Politica de confidențialitate
              </router-link>
              <span class="dot-separator">•</span>
              <router-link :to="{ name: 'public.terms' }" class="legal-link">
                Termeni și Condiții
              </router-link>
              <span class="dot-separator">•</span>
              <a target="_blank" href="https://anpc.ro/" class="legal-link">A.N.P.C</a>
            </div>
          </div>
        </b-col>

        <!-- Dreapta: Metode de plată și Credit autor -->
        <b-col md="5" lg="4" class="text-center text-md-right">
          <div class="payment-methods-wrapper">
            <div class="payment-logos">
              <b-img :src="mastercardLogo" fluid alt="Mastercard" class="pay-logo"></b-img>
              <b-img :src="visaLogo" fluid alt="Visa" class="pay-logo"></b-img>
            </div>
            <p class="developer-credit">
              Built with ❤️ by <a href="https://lioncode.ro" target="_blank" rel="nofollow" class="credit-link">LionCode.ro</a>
            </p>
          </div>
        </b-col>

      </b-row>

    </b-container>
  </footer>
</template>

<script>
export default {
  name: "FooterNav",
  data() {
    return {
      mastercardLogo: process.env.VUE_APP_MASTERCARD_LOGO_PATH,
      visaLogo: process.env.VUE_APP_VISA_LOGO_PATH,
      filters: {},
    }
  }
}
</script>

<style scoped>
/* Apple Light Footer Theme */
.apple-tesla-footer {
  background-color: #ffffff;
  color: #1d1d1f;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 0.88rem;
  -webkit-font-smoothing: antialiased;
}

/* Headings */
.footer-heading {
  font-size: 0.82rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #86868b;
  margin-bottom: 16px;
}

.footer-subtext {
  font-size: 0.85rem;
  color: #6e6e73;
  margin-bottom: 16px;
  line-height: 1.4;
}

/* Links List */
.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-link {
  color: #1d1d1f !important;
  text-decoration: none !important;
  font-weight: 400;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: color 0.2s ease, opacity 0.2s ease;
}

.footer-link:hover {
  color: #0071e3 !important;
  opacity: 0.85;
}

.muted-link {
  color: #86868b !important;
}

.social-icon {
  color: #515154;
  transition: color 0.2s ease;
}

.footer-link:hover .social-icon {
  color: #0071e3;
}

/* App Download Chips */
.app-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.app-chip-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #f2f2f7;
  color: #1d1d1f !important;
  padding: 8px 14px;
  border-radius: 980px;
  font-size: 0.8rem;
  font-weight: 500;
  text-decoration: none !important;
  transition: all 0.2s ease;
  border: 1px solid #e5e5ea;
}

.app-chip-btn:hover {
  background-color: #0071e3;
  color: #ffffff !important;
  border-color: #0071e3;
  transform: translateY(-1px);
}

/* Contact Email */
.contact-email {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
}

.email-label {
  color: #86868b;
}

.email-link {
  color: #0071e3 !important;
  text-decoration: none !important;
  font-weight: 500;
}

.email-link:hover {
  text-decoration: underline !important;
}

/* Divider */
.footer-divider {
  border: 0;
  border-top: 1px solid #e5e5ea;
}

/* Container Unificat Legal & Copyright */
.bottom-legal-info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 0.78rem;
  line-height: 1.5;
}

@media (max-width: 767.98px) {
  .bottom-legal-info {
    justify-content: center;
    flex-direction: column;
    gap: 4px;
  }
}

.copyright-text {
  color: #86868b;
  margin: 0;
}

.legal-inline-links {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.legal-link {
  color: #6e6e73 !important;
  text-decoration: none !important;
  transition: color 0.2s ease;
}

.legal-link:hover {
  color: #0071e3 !important;
}

.dot-separator {
  color: #c7c7cc;
}

/* Payment Logos */
.payment-methods-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (min-width: 768px) {
  .payment-methods-wrapper {
    align-items: flex-end;
  }
}

.payment-logos {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 6px;
}

.pay-logo {
  max-height: 24px;
  width: auto;
  opacity: 0.85;
  transition: opacity 0.2s ease;
}

.pay-logo:hover {
  opacity: 1;
}

.developer-credit {
  font-size: 0.75rem;
  color: #86868b;
  margin: 0;
}

.credit-link {
  color: #515154 !important;
  font-weight: 500;
  text-decoration: none !important;
}

.credit-link:hover {
  color: #0071e3 !important;
}
</style>
